module.exports = __webpack_public_path__ + "static/upperLeftPocket-3bfbaa7c91532b80dc29d63e51a0a96a.png";